// src/components/user/Masivo/ValidationProgress.jsx
import React from 'react';
import { Loader2, FileSearch } from 'lucide-react';

function ValidationProgress({ totalRows, processedRows }) {
  const percentage = totalRows > 0 ? Math.round((processedRows / totalRows) * 100) : 0;

  return (
    <div className="bg-white rounded-2xl border-2 border-slate-200 p-6 sm:p-8">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-brand-primary to-[#E6B43C] flex items-center justify-center mb-6 relative">
          <Loader2 className="w-8 h-8 text-white animate-spin" />
          <div className="absolute inset-0 rounded-full border-4 border-white/30 animate-pulse" />
        </div>

        <h2 className="text-2xl font-extrabold text-brand-primary font-montserrat mb-2">
          Validando archivo...
        </h2>
        <p className="text-sm text-slate-600 font-montserrat mb-6">
          Revisando {totalRows} entrega{totalRows !== 1 ? 's' : ''}
        </p>

        {/* Progress bar */}
        <div className="w-full max-w-md">
          <div className="bg-slate-200 rounded-full h-3 mb-2 overflow-hidden">
            <div 
              className="bg-gradient-to-r from-brand-primary to-brand-green h-full transition-all duration-300 ease-out rounded-full"
              style={{ width: `${percentage}%` }}
            />
          </div>
          <p className="text-xs text-slate-500 font-montserrat">
            {percentage}% completado
          </p>
        </div>

        {/* Animation */}
        <div className="mt-8 flex items-center gap-2 text-slate-400">
          <FileSearch className="w-5 h-5 animate-pulse" />
          <span className="text-xs font-montserrat">Verificando datos...</span>
        </div>
      </div>
    </div>
  );
}

export default ValidationProgress;